module.exports = __webpack_public_path__ + "img/video.27b123f2.svg";